import { isReelLike } from '@/helpers/isReelLike';

export const headerLine = (count, groupName = '') => {
  const isMobile = typeof window !== 'undefined' && window.storeeelItems?.isMobile;
  // リール型・タイル型ではヘッダーラインをスライド内に配置する
  const isMobileReel = isMobile && isReelLike(window.storeeelItems?.frame);
  const widthValue = isMobile ? '92%' : '80%';
  const bannerWidth = isMobile ? '100%' : `calc(100% / ${count})`;

  const headerTop = isMobile ? '16px' : '-20px';
  let groupStyles = 'position: absolute; top: -35px; left: 4px; font-size: 18px;';
  if (isMobileReel) {
    groupStyles = 'position: absolute; top: 8px; left: 1%; font-size: 14px;';
  } else if (isMobile) {
    groupStyles = 'position: fixed; top: 8px; left: 1%; font-size: 14px;';
  }

  const headerPointerEvents = isMobile ? 'pointer-events: auto;' : '';

  let wrapperStyles = '';
  if (isMobileReel) {
    wrapperStyles = `
      :host(.storeeel-header-wrapper) {
        display: flex;
        z-index: 99;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        padding: 16px;
        background: linear-gradient(0deg, rgba(153, 153, 153, 0) 0%, #999 172.86%);
        height: 103px;
        pointer-events: none;
      }
    `;
  } else if (isMobile) {
    wrapperStyles = `
      :host(.storeeel-header-wrapper) {
        display: flex;
        z-index: 99;
        position: fixed;
        width: 100vw;
        padding: 16px;
        background: linear-gradient(0deg, rgba(153, 153, 153, 0) 0%, #999 172.86%);
        height: 103px;
        pointer-events: none;
      }
    `;
  }

  const host = document.createElement('storeeel-header-host');
  host.setAttribute('data-storeeel-header-host', '');
  if (isMobile) {
    host.classList.add('storeeel-header-wrapper');
  }

  const shadowRoot = host.attachShadow({ mode: 'open' });
  const styleTag = document.createElement('style');
  styleTag.textContent = `
    ${wrapperStyles}
    .storeeel-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      z-index: 100;
      top: ${headerTop};
      width: ${widthValue};
      left: 50%;
      transform: translateX(-50%);
      position: ${isMobileReel ? 'absolute' : 'fixed'};
      ${headerPointerEvents}
    }

    .storeeel-group-name {
      ${groupStyles}
      font-weight: bold;
      color: white;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 100%;
    }

    .storeeel-movie-select_banner {
      width: ${bannerWidth};
      height: 3px;
      background-color: rgba(255, 255, 255, 0.2);
      margin: 0 3px;
      padding: 0 !important;
      position: relative;
      overflow: hidden;
      display: block !important;
    }

    .storeeel-movie-select_banner::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      background-color: white;
      width: 0%;
      animation: none;
    }

    .storeeel-movie-select_banner.active::before {
      animation: progressBarAnimation var(--duration, 3s) linear forwards;
      animation-delay: var(--progress-delay, 0s);
    }

    .storeeel-movie-select_banner.completed::before {
      width: 100%;
      background-color: white;
      animation: none;
    }

    .storeeel-movie-select_banner.paused::before {
      animation-play-state: paused !important;
    }

    @keyframes progressBarAnimation {
      0% { width: 0%; }
      100% { width: 100%; }
    }
  `;

  const header = document.createElement('div');
  header.className = 'storeeel-header';

  const groupNameEl = document.createElement('div');
  groupNameEl.className = 'storeeel-group-name';
  groupNameEl.textContent = groupName;
  header.appendChild(groupNameEl);

  for (let i = 0; i < count; i++) {
    const banner = document.createElement('div');
    banner.className = 'storeeel-movie-select_banner';
    banner.dataset.index = String(i);
    header.appendChild(banner);
  }

  shadowRoot.appendChild(styleTag);
  shadowRoot.appendChild(header);

  return host;
};
